import { ref } from 'vue';
import { SessionStorage } from 'quasar';

export function useBannerFlag(key: string) {
  const show = ref(false);

  function set() {
    SessionStorage.set(key, true);
    show.value = true;
  }

  function checkAndClear() {
    const shouldShow = !!SessionStorage.getItem(key);
    if (shouldShow) {
      SessionStorage.remove(key);
      show.value = true;
    } else {
      show.value = false;
    }
    return show.value;
  }

  function clear() {
    SessionStorage.remove(key);
    show.value = false;
  }

  return {
    show,
    set,
    checkAndClear,
    clear,
  };
}
